<div class="modal" id="enrollStudents" tabindex="-1" role="dialog" style="direction: ltr;" data-backdrop="static"
    data-keyboard="false">
    <div class="modal-dialog">
        <div class="modal-content" [ngStyle]="{'direction': currLang == 'en' ? 'ltr' : 'rtl'}">
            <div *ngIf="loading" class="loading">
                <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
            </div>
            <div class="modal-header">
                <div>
                    <h5 class="modal-title">{{'buses.enroll-bus.header' | translate}}</h5>
                </div>
                <div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
            <div class="modal-body">
                <div class="side-bar">
                    <app-filter [listType]="listType"></app-filter>
                </div>
                <div class="enroll-students-body">
                    <div class="control-bar-section">
                        <app-control-bar [listType]="listType"></app-control-bar>
                        <button [disabled]="selectedStudentsToAddToBuses.length === 0 ? true : false"
                            (click)="enrollStudentsInBusSystem()"
                            class="btn btn-primary enroll">{{'buses.enroll-bus.enroll' | translate}}</button>
                    </div>
                    <div class="students-wrapper">
                        <div class="all-students">
                            <div class="all-students-list">
                                <!-- <app-loading></app-loading> -->
                                <app-table-view *ngIf="tableControls.data.length > 0 || (tableControls.data?.length === 0 && searchText) || (tableControls.data?.length === 0 && filterValues.grades?.length != 0)  && !loading" [controls]="tableControls"
                                    (eventHandeler)="tableEventHandeler($event)" [showSideBar]="false"></app-table-view>
                            </div>
                        </div>
                        <div class="all-selected-students">
                            <app-selected-students-table (eventHandeler2)="selectedStudentsEventHandler($event)"
                                [selectedStudentsToAdd]="selectedStudentsToAddToBuses" [listFlag]="modalFlag" [currLang]="currLang">
                            </app-selected-students-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>